module.exports = __webpack_public_path__ + "static/media/thumbnail-unic.00493b28.jpg";